import React, { useState } from 'react';
import { ConsoleShell, useConsoleTheme } from '../components/Console';
import { Card, CardTitle, Insight } from '../components/UI';
import { supabase } from '../supabaseClient';
import { getDisplayAddress } from '../utils/location';
const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
const TYPES = ['Hospital','Clinic','Doctor','GP','Dentist','Pharmacy','Spa','Wellness','Gym','Fitness','Yoga','Hair Salon','Nail Salon','Barbershop','Massage','Hotel & Resort','Mental Health','Physiotherapy','Veterinary'];
function useIsMobile() {
  const [m,setM]=React.useState(()=>typeof window!=='undefined'&&window.innerWidth<768);
  React.useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);
  return m;
}
function Field({label,value,onChange,type='text',options}) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:'.65rem',color:'var(--color-text-secondary)',textTransform:'uppercase',letterSpacing:'.04em',marginBottom:3}}>{label}</div>
      {options
        ? <select value={value||''} onChange={e=>onChange(e.target.value)} style={{width:'100%',padding:'6px 10px',borderRadius:7,border:'1px solid var(--color-border-secondary)',background:'var(--color-background-secondary)',color:'var(--color-text-primary)',fontSize:'.78rem',fontFamily:F}}>
            <option value="">—</option>{options.map(o=><option key={o}>{o}</option>)}
          </select>
        : <input type={type} value={value||''} onChange={e=>onChange(e.target.value)}
            style={{width:'100%',padding:'6px 10px',borderRadius:7,border:'1px solid var(--color-border-secondary)',background:'var(--color-background-secondary)',color:'var(--color-text-primary)',fontSize:'.78rem',fontFamily:F,boxSizing:'border-box'}}/>
      }
    </div>
  );
}
function LocationProfileBody() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const isMobile = useIsMobile();
  const [query,setQuery]=useState('');
  const [results,setResults]=useState([]);
  const [selected,setSelected]=useState(null);
  const [edits,setEdits]=useState({});
  const [loading,setLoading]=useState(false);
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');

  const search = async () => {
    if (!query.trim()) return;
    setLoading(true); setResults([]); setSelected(null);
    const { data } = await supabase.from('Locations')
      .select('id,name,type,city,country,address,formatted_address,phone,website,latitude,longitude,last_verified,geocode_status,tags,notes,telehealth,er_24_7,languages,booking_url')
      .or(`name.ilike.*${query}*,city.ilike.*${query}*,country.ilike.*${query}*`)
      .limit(20);
    setResults(data||[]); setLoading(false);
  };

  const open = (r) => { setSelected(r); setEdits({...r}); setMsg(''); };

  const set = (k,v) => setEdits(e=>({...e,[k]:v}));

  const save = async () => {
    setSaving(true);
    const { error } = await supabase.from('Locations').update(edits).eq('id', selected.id);
    if (error) setMsg('Error: '+error.message);
    else { setMsg('✓ Saved'); setResults(prev=>prev.map(r=>r.id===selected.id?{...r,...edits}:r)); setSelected({...selected,...edits}); }
    setSaving(false);
  };

  const S = { th:{fontSize:'.65rem',color:'var(--color-text-secondary)',textTransform:'uppercase',letterSpacing:'.04em',padding:'6px 8px',textAlign:'left',borderBottom:'1px solid var(--color-border-tertiary)',fontWeight:500}, td:{fontSize:'.75rem',padding:'7px 8px',borderBottom:'.5px solid var(--color-border-tertiary)',color:'var(--color-text-primary)',cursor:'pointer'} };

  return (
    <div style={{fontFamily:F,padding:isMobile?'16px 14px 80px':'24px 28px'}}>
      <div style={{marginBottom:16}}>
        <h2 style={{fontSize:'1.1rem',fontWeight:500,margin:0,color:'var(--color-text-primary)'}}>Location search & profile</h2>
        <p style={{fontSize:'.78rem',color:'var(--color-text-secondary)',margin:'4px 0 0'}}>Search by name, city, or country. Click any result to view and edit the full record.</p>
      </div>
      <div style={{display:'flex',gap:8,marginBottom:16}}>
        <input value={query} onChange={e=>setQuery(e.target.value)} onKeyDown={e=>e.key==='Enter'&&search()} placeholder="Search by name, city, or country…"
          style={{flex:1,padding:'8px 12px',borderRadius:8,border:'1px solid var(--color-border-secondary)',background:'var(--color-background-secondary)',color:'var(--color-text-primary)',fontSize:'.78rem',fontFamily:F}}/>
        <button onClick={search} disabled={loading||!query.trim()} style={{padding:'8px 18px',borderRadius:8,background:t.accent,color:'#AFE1F6',border:'none',fontSize:'.78rem',fontWeight:500,cursor:'pointer',fontFamily:F}}>
          {loading?'Searching…':'Search'}
        </button>
      </div>
      <div style={{display:'grid',gridTemplateColumns:selected&&!isMobile?'1fr 400px':'1fr',gap:16,alignItems:'start'}}>
        {results.length>0&&(
          <Card>
            <CardTitle>{results.length} results — click to edit</CardTitle>
            <div style={{overflowX:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse',minWidth:360}}>
                <thead><tr><th style={S.th}>Name</th><th style={S.th}>Type</th><th style={S.th}>City</th><th style={S.th}>Country</th><th style={S.th}>GPS</th></tr></thead>
                <tbody>{results.map(r=>(
                  <tr key={r.id} onClick={()=>open(r)} style={{background:selected?.id===r.id?'rgba(49,79,92,0.06)':'',transition:'background .1s'}}>
                    <td style={{...S.td,fontWeight:500}}>{r.name}</td>
                    <td style={S.td}>{r.type||'—'}</td>
                    <td style={S.td}>{r.city||'—'}</td>
                    <td style={S.td}>{r.country||'—'}</td>
                    <td style={S.td}>{r.latitude?<span style={{color:'#28a745'}}>✓</span>:<span style={{color:'#dc3545'}}>✗</span>}</td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          <div style={{display:'flex',justifyContent:'flex-end',marginTop:8}}>
            <button onClick={()=>{
              const cols=['id','name','type','city','country','phone','website','latitude','longitude'];
              const csv=[cols.join(','),...results.map(r=>cols.map(c=>`"${(r[c]||'').toString().replace(/"/g,'""')}"`).join(','))].join('\n');
              const a=document.createElement('a');a.href='data:text/csv;charset=utf-8,'+encodeURIComponent(csv);a.download='search_results.csv';a.click();
            }} style={{fontSize:'.7rem',color:t.mut,background:'none',border:'1px solid var(--color-border-secondary)',borderRadius:6,padding:'4px 10px',cursor:'pointer',fontFamily:F}}>
              ↓ Export CSV ({results.length})
            </button>
          </div>
          </Card>
        )}
        {selected&&(
          <Card style={{position:isMobile?'static':'sticky',top:16}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12}}>
              <CardTitle style={{marginBottom:0}}>{selected.name}</CardTitle>
              <button onClick={()=>setSelected(null)} style={{background:'none',border:'none',color:'var(--color-text-secondary)',cursor:'pointer',fontSize:16,padding:'0 4px'}}>×</button>
            </div>
            <Field label="Name" value={edits.name} onChange={v=>set('name',v)} />
            <Field label="Type" value={edits.type} onChange={v=>set('type',v)} options={TYPES} />
            <Field label="City" value={edits.city} onChange={v=>set('city',v)} />
            <Field label="Country" value={edits.country} onChange={v=>set('country',v)} />
            <Field label="Address" value={edits.address} onChange={v=>set('address',v)} />
            <Field label="Phone" value={edits.phone} onChange={v=>set('phone',v)} />
            <Field label="Website" value={edits.website} onChange={v=>set('website',v)} />
            <Field label="Booking URL" value={edits.booking_url} onChange={v=>set('booking_url',v)} />
            <Field label="Languages" value={edits.languages} onChange={v=>set('languages',v)} />
            <Field label="Tags" value={edits.tags} onChange={v=>set('tags',v)} />
            <Field label="Notes" value={edits.notes} onChange={v=>set('notes',v)} />
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:10}}>
              <Field label="Latitude" value={edits.latitude} onChange={v=>set('latitude',parseFloat(v)||null)} type="number" />
              <Field label="Longitude" value={edits.longitude} onChange={v=>set('longitude',parseFloat(v)||null)} type="number" />
            </div>
            <div style={{display:'flex',gap:10,marginBottom:10}}>
              {[['telehealth','Telehealth'],['er_24_7','ER 24/7']].map(([k,l])=>(
                <label key={k} style={{display:'flex',alignItems:'center',gap:5,fontSize:'.75rem',color:'var(--color-text-secondary)',cursor:'pointer'}}>
                  <input type="checkbox" checked={!!edits[k]} onChange={e=>set(k,e.target.checked)} />{l}
                </label>
              ))}
            </div>
            {msg&&<Insight type={msg.startsWith('✓')?'ok':'warn'} style={{marginBottom:8}}>{msg}</Insight>}
            <button onClick={save} disabled={saving} style={{width:'100%',padding:'8px',borderRadius:8,background:t.accent,color:'#AFE1F6',border:'none',fontSize:'.78rem',fontWeight:500,cursor:'pointer',fontFamily:F}}>
              {saving?'Saving…':'Save changes'}
            </button>
            {selected.website&&<a href={selected.website} target="_blank" rel="noreferrer" style={{display:'block',textAlign:'center',marginTop:8,fontSize:'.7rem',color:t.mut}}>Open website →</a>}
          </Card>
        )}
      </div>
    </div>
  );
}

export default function LocationProfile(props) {
  if (props && props.embed) return <LocationProfileBody {...props} />;
  return <ConsoleShell title="Location Search"><LocationProfileBody {...props} /></ConsoleShell>;
}
